import { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export default function AutoLogin() {
  const [searchParams] = useSearchParams();
  const { loginWithMagicLink, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [tab, setTab] = useState(null);

  // Step 1: call the magic-login API
  useEffect(() => {
    const token = searchParams.get('t');
    if (!token) {
      setError('Invalid link — no token found.');
      return;
    }

    loginWithMagicLink(token)
      .then((result) => {
        setTab(result?.tab || null);
        setDone(true);
      })
      .catch(err => setError(err?.response?.data?.error || err.message || 'This link is invalid or has expired.'));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Step 2: navigate only once both the API call succeeded AND user is set in context
  useEffect(() => {
    if (done && user) {
      navigate(tab ? `/account?tab=${tab}` : '/account', { replace: true });
    }
  }, [done, user, tab, navigate]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif', padding: '2rem' }}>
      {error ? (
        <>
          <p style={{ color: '#c0392b', fontSize: '1rem', marginBottom: '1rem' }}>{error}</p>
          <a href="/login" style={{ color: '#e07b39', fontWeight: 600 }}>Go to Login</a>
        </>
      ) : (
        <p style={{ color: '#555', fontSize: '1rem' }}>Signing you in…</p>
      )}
    </div>
  );
}
